<div class="layout-footer">
    <img src="assets/layout/images/mitsat_logo.png" style="width: 50px;" alt="footer-logo">
    
    <div *ngIf="layoutService.state.footerLegendVisible" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; text-align: center; flex: 1; margin: 0 2rem;">
        <div style="background-color: #d4edda; padding: 8px; border-radius: 4px; border: 1px solid #c3e6cb;">
            <strong>Maior que 90%</strong>
        </div>
        <div style="background-color: #fff3cd; padding: 8px; border-radius: 4px; border: 1px solid #ffeaa7;">
            <strong>Entre o mínimo da estação e 90%</strong>
        </div>
        <div style="background-color: #f8d7da; padding: 8px; border-radius: 4px; border: 1px solid #f5c6cb;">
            <strong>Abaixo do mínimo da estação</strong>
        </div>
        <div style="background-color: #ccc; padding: 8px; border-radius: 4px; border: 1px solid #999;">
            <strong>Sensor não Instalado ou Desativado</strong>
        </div>
    </div>
</div>